import { v4 } from 'uuid'

/**
 * Jednoduchý service (třída) pro práci s localStorage ohledně autentizačních dat.
 * - UUID: uložení/načtení/smazání
 * - Tokeny: uložení/načtení access/refresh tokenu/smazání
 */

// export interface AuthTokens {
//   access_token?: string
//   refresh_token?: string
// }

export class AuthStorage {
  private readonly UUID_KEY = 'uuid'
  // private readonly TOKEN_KEY = 'tokens'

  // UUID
  public setUuid(uuid: string): void {
    localStorage.setItem(this.UUID_KEY, uuid)
  }

  public newUuid(): string {
    const newUuid = v4()
    this.setUuid(newUuid)
    return newUuid
  }

  public getUuid(): string | null {
    return localStorage.getItem(this.UUID_KEY)
  }

  public clearUuid(): void {
    localStorage.removeItem(this.UUID_KEY)
  }

  // Tokeny
  // public setTokens(tokens: AuthTokens): void {
  //   try {
  //     localStorage.setItem(this.TOKEN_KEY, JSON.stringify(tokens || {}))
  //   } catch {
  //     // no-op
  //   }
  // }

  // public getTokens(): AuthTokens {
  //   try {
  //     const raw = localStorage.getItem(this.TOKEN_KEY)
  //     if (!raw) return {}
  //     const parsed = JSON.parse(raw)
  //     return typeof parsed === 'object' && parsed ? parsed as AuthTokens : {}
  //   } catch {
  //     return {}
  //   }
  // }

  // public getAccessToken(): string | undefined {
  //   return this.getTokens().access_token
  // }

  // public getRefreshToken(): string | undefined {
  //   return this.getTokens().refresh_token
  // }
  //
  // public clearTokens(): void {
  //   localStorage.removeItem(this.TOKEN_KEY)
  // }

  // Vše
  // public clearAll(): void {
  //   // this.clearTokens()
  //   this.clearUuid()
  // }
}

// Singleton instance pro pohodlné použití
const authStorage = new AuthStorage()
export default authStorage
